import api from '../../plugins/api';

const getDealItemsCount = (params) => {
  return api.get('/api/crm/deals/getDealItemsCount', params);
};

export default getDealItemsCount;
